'use client'
import { useMasterData } from 'master-data/hooks/useMasterData/useMasterData'
import { useMasterDataIsReady } from 'master-data/hooks/useMasterDataIsReady/useMasterDataIsReady'
import { useSetMasterData } from 'master-data/hooks/useSetMasterData/useSetMasterData'
import { useFiltersSearchParams } from 'product-list/hooks/useFiltersSearchParams/useFiltersSearchParams'
import { updateMasterDataItemListName } from 'product-list/hooks/usePushFiltersSearchParams/analytics'
import { useEffect, useMemo, useRef } from 'react'
import { withItemListDomainData } from 'types/masterData/domainData/domainData'

export const PlpPageView = () => {
	const masterData = useMasterData()

	const initialPageViewSent = useRef(false)

	const { updateMasterData } = useSetMasterData()
	const { setMasterDataIsReady } = useMasterDataIsReady()
	const { hasFiltersApplied } = useFiltersSearchParams()

	const domainData = useMemo(() => {
		if (!withItemListDomainData(masterData.custom)) {
			return null
		}
		return masterData.custom
	}, [masterData.custom])

	useEffect(() => {
		if (!initialPageViewSent.current && domainData?.item_list_name) {
			initialPageViewSent.current = true
			const newMasterData = updateMasterDataItemListName(
				domainData.item_list_name,
				window.location.href,
				hasFiltersApplied
			)
			updateMasterData(newMasterData)
			setMasterDataIsReady(true)
		}
	}, [
		domainData?.item_list_name,
		hasFiltersApplied,
		updateMasterData,
		setMasterDataIsReady,
	])

	return null
}
